<template>
    <div class="i-surveys-form-input">
        <form-item v-bind="$attrs">
            <van-field
                v-model="displayValue"
                placeholder="请选择"
                :rules="rules"
                :readonly="true"
                :name="itemKey"
                @click-input="showPicker"
            >
                <template #button>
                    <van-button 
                        v-if="modelValue && !isDisabled" 
                        size="small" 
                        type="primary" 
                        @click.stop="clearSelection"
                    >
                        清空
                    </van-button>
                </template>
            </van-field>
        </form-item>

        <van-popup v-model="show" position="bottom" style="height:50%">
            <div class="popup-wrapper">
                <div class="popup-header">
                    <van-search
                        v-model="search"
                        show-action
                        placeholder="请输入搜索"
                        @search="onSearch"
                        @cancel="onCancel"
                    />
                    <div class="clear-option" @click="clearSelection">
                        <van-icon name="delete" />
                        <span>清空已选</span>
                    </div>
                </div>

                <div class="popup-body">
                    <van-radio-group v-model="radio">
                        <van-cell-group>
                            <van-cell
                                v-for="(item, index) in filteredOptions"
                                :key="index"
                                :title="item.name"
                                clickable
                                @click="selectOption(item)"
                            >
                                <template #right-icon>
                                    <van-radio :name="item.name" checked-color="var(--color-primary)"/>
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import FormItem from './form-item.vue'

export default {
    components: { FormItem },
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        rules: {
            type: Array,
            default: () => ([])
        },
        options: {
            type: Array,
            default: () => ([])
        },
        itemKey: {
            type: String,
            default: ''
        }
    },
    computed: {
        modelValue: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        },
        displayValue () {
            return this.modelValue || ''
        },
        filteredOptions () {
            if (!this.search) {
                return this.options
            }
            const keyword = this.search.toLowerCase()
            return this.options.filter(item =>
                item.name.toLowerCase().includes(keyword)
            )
        },
        isDisabled () {
            return this.$route.query.formType === 'preview'
        }
    },
    data () {
        return {
            search: '',
            show: false,
            radio: ''
        }
    },
    methods: {
        clearSelection () {
            this.modelValue = ''
            this.radio = ''
        },
        onSearch () {
            // Client-side filtering, no need for API call
        },
        showPicker () {
            if (!this.isDisabled) {
                this.show = true
                this.radio = this.modelValue
            }
        },
        selectOption (item) {
            this.modelValue = item.name
            this.radio = item.name
            this.show = false
            this.$emit('sumBlur')
        },
        onCancel () {
            this.show = false
        }
    }
}
</script>

<style scoped>
.popup-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.popup-header {
    position: relative;
    flex-shrink: 0;
}

.popup-body {
    flex: 1;
    overflow-y: auto;
}

.clear-option {
    position: absolute;
    right: 60px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    font-size: 14px;
    color: var(--color-primary);
    z-index: 1;
    padding: 8px;
    cursor: pointer;
}

.clear-option .van-icon {
    margin-right: 4px;
}
</style>
